// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import { welcomeMessageStyles } from "@steiner/App/Widgets/WelcomeMessage/WelcomeMessage";
import { createLinkIconStyles, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

welcomeMessageStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};
welcomeMessageStyles.welcomeMessageWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        gap: 32px;
        flex-wrap: wrap;
        ${xScreen("lte", "xs")} {
            gap: 0;
            flex-direction: column;
            align-items: flex-start;
        }
    `,
};
welcomeMessageStyles.welcomeText = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
    `,
};
welcomeMessageStyles.dashboardLink = {
    ...createLinkIconStyles({
        icon: ChevronRight,
        linkStyles: {
            icon: {
                position: "right",
                iconProps: {
                    size: 13,
                },
            },
            css: css`
                margin-top: 10px;
                ${xScreen("lte", "xs")} {
                    margin-top: 8px;
                }
            `,
        },
    }),
};
